import { AutoComplete, Select } from "antd";
import { useGetEnumItemsQuery } from "../../../../api/plamo-api";
import { useAdvancedFormContext } from "../advanced-form";
import { InputStyled } from "./form-item-string";
import { useMemo } from "react";
import styled from "styled-components";

const ReadOnlySelectStyled = styled(Select)`
  .ant-select-selector {
    background: none !important;
  }

  .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.88) !important;
    background: none !important;
  }

  .ant-select-arrow {
    display: none;
  }
`

function FormItemBackendEnum({ value, onChange, readOnly, disabled, typeData, placeholder }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly
  const { data: values } = useGetEnumItemsQuery({ f: JSON.stringify({ "referencedEnum.ident": { c: "EQ", v: typeData.ident }}), st: JSON.stringify({ orderIdx: "asc" }) }) as any;

  const readOnlyValues = useMemo(() => (!Array.isArray(value) ? [value] : value).map(singleValue => (values?.items || []).find(v => v.value === singleValue)?.label || value).join(", "), [values, value])

  return <>
    { !effectiveReadOnly && !typeData.allowCustomValue && <Select allowClear value={value} onChange={onChange} disabled={readOnly || disabled} options={values?.items || []} showSearch={typeData?.showSearch} mode={typeData.multiple ? "multiple" : undefined} />}
    { !effectiveReadOnly && typeData.allowCustomValue && <AutoComplete
      allowClear
      options={values?.items || []}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      filterOption={(inputValue, option) =>
        `${option!.value}`.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
      }
    />}
    { effectiveReadOnly && !typeData.multiple && <InputStyled value={readOnlyValues} readOnly />}
    { effectiveReadOnly && typeData.multiple && <ReadOnlySelectStyled value={value} options={values?.items || []} disabled mode="multiple" />}
  </>
}

export default FormItemBackendEnum;
